var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "numpad" },
    _vm._l(_vm.keyList, function (key) {
      return _c(
        "div",
        {
          key: key.k,
          staticClass: "np-key",
          class: [key.cls, { "np-disabled": key.disabled }],
          style: key.style,
          attrs: { role: "button" },
          on: {
            click: function ($event) {
              return _vm.press(key)
            },
          },
        },
        [
          key.k === "ok"
            ? _vm._l(key.label.split(""), function (ch, i) {
                return _c("span", { key: i, staticClass: "np-confirm-ch" }, [
                  _vm._v(_vm._s(ch)),
                ])
              })
            : key.label
            ? _c("span", [_vm._v(_vm._s(key.label))])
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }